import script from "./CustomForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomForm.vue?vue&type=script&lang=ts&setup=true"

import "./CustomForm.vue?vue&type=style&index=0&id=430ea676&lang=css"

const __exports__ = script;

export default __exports__